import { all, fork } from "redux-saga/effects";
import CommonSaga from "./CommonSaga";

export default function* rootSaga() {
  yield all([fork(CommonSaga)]);
}
